import { ErrorHandler, inject, Injectable } from '@angular/core';
import { RrsToastService } from '@app/custom/features/rrs-toast/services/rrs-toast.service';
import { take } from 'rxjs/operators';
@Injectable()
export class RrsGlobalErrorHandler implements ErrorHandler {
  rrsToastService = inject(RrsToastService);
  handleError(error: any): void {
    if (error?.message?.includes('ChunkLoadError')) {
      this.rrsToastService.showToast({
        toastHeaderText: 'Uh oh!',
        toastBody:
          "There's been an unexpected error, please refresh to continue shopping.",
        toastButtonText: 'Refresh',
        toastPostion: 'left-bottom border-danger',
        headerIconFileName: 'red-circle-cross.svg',
      });
      this.rrsToastService.callbackResponse.pipe(take(1)).subscribe((res) => {
        if (res) window.location.reload();
      });
    }
  }
}
